import { Box } from "@mui/material";
import Logo from "../components/common/Logo";

const Fallback = () => {
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        WebkitAnimation: "fadeinout 1s linear forwards",
        animation: "fadeinout 1s linear forwards",
      }}
    >
      <Logo />
    </Box>
  );
};

export default Fallback;
